import React from 'react';
import { tv } from 'tailwind-variants';
import { MenuItemType } from 'types';

export const headerContent = tv({
  base: 'left-0 right-0 shadow',
  variants: {
    position: {
      sticky: 'sticky top-0',
      fixed: 'fixed top-[120px] z-20',
    },
    size: {
      md: 'px-6 py-[18px]',
      sm: 'px-6 py-3 rounded-t-lg',
    },
    background: {
      transparent: 'bg-transparent',
      white: 'bg-white',
    },
  },
  defaultVariants: {
    position: 'sticky',
    size: 'md',
    background: 'white',
  },
});

const HeaderContent: React.FC<
  MenuItemType & { background?: 'white' | 'transparent'; size?: 'sm' | 'md'; className?: string }
> = ({ label, contentHeader, size = 'md', className = '', background = 'white' }) => {
  return (
    <div className={`${headerContent({ size, background })} ${className}`}>
      <h1 className='text-lg 2xl:text-xl font-bold uppercase !leading-[22px]'>{label}</h1>
      {contentHeader && <p className='text-sm text-[var(--textBlack56)] mt-2 leading-[22px]'>{contentHeader}</p>}
    </div>
  );
};

export default HeaderContent;
